<template>
  <span
    :key="value"
    class="safe-phone notranslate"
    style="font: inherit; font-weight: inherit; color: inherit;"
    data-sl-dialer="off"
    data-rc-call-ignore="true"
    data-no-dialer="true"
  >{{ value }}</span>
</template>

<script>
export default {
  name: 'SafePhone',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
